import request from 'utils/request'

export default {
  getTestResults(payload) {
    return request.post('/api/test-result', payload);
  },
}